export const CONTACT = {
  company: "Kerala Holidays Connect",
  logo: "https://customer-assets-cm19k8pv.emergentagent.net/job_backwater-dreams/artifacts/9w09qz68_1000372184.png",
  tagline: "Your Trusted Mumbai to Kerala Travel Partner",
  website: "https://keralaholidaysconnect.com",
  phone: "+91 90044 06641",
  phoneRaw: "+919004406641",
  whatsapp: "919004406641",
  email: "kunnummalveettilashokan@gmail.com",
  address: "A1 Venkateshwara CHS, Dombivli, Maharashtra, India",
  social: {
    facebook: "https://facebook.com",
    instagram: "https://instagram.com",
    youtube: "https://youtube.com",
  },
  mapEmbed:
    "https://www.google.com/maps?q=Dombivli%2C%20Maharashtra&output=embed",
};

export const IMAGES = {
  munnarHero: "https://images.unsplash.com/photo-1720591658325-90372cc7da02",
  munnarValley: "https://images.unsplash.com/photo-1723214520491-7f90eeda2cdd",
  alleppeyAerial: "https://images.unsplash.com/photo-1602216056096-3b40cc0c9944",
  alleppey2: "https://images.unsplash.com/photo-1609828913552-f9138ed9e42d",
  houseboatClose: "https://images.unsplash.com/photo-1593693397690-362cb9666fc2",
  backwaterBoat: "https://images.unsplash.com/photo-1643614331150-37823121afce",
  backwaterSunset: "https://images.unsplash.com/photo-1602094395895-fb8070114e38",
  athirappilly: "https://images.unsplash.com/photo-1669111685793-600c1abbbb06",
  athirappillyAerial: "https://images.unsplash.com/photo-1575305327780-a887f284432f",
  kathakali: "https://images.unsplash.com/photo-1597735881932-d9664c9bbcea",
  fishingNets: "https://images.unsplash.com/photo-1590123732197-e7079d2ceb89",
  hotel: "https://images.pexels.com/photos/7507131/pexels-photo-7507131.jpeg",
  family: "https://images.pexels.com/photos/14349728/pexels-photo-14349728.jpeg",
};

export const HERO_VIDEO = "https://videos.pexels.com/video-files/3337853/3337853-hd_1920_1080_30fps.mp4";

export const HERO_SLIDES = [
  { img: IMAGES.munnarHero, place: "Munnar", caption: "Emerald tea gardens" },
  { img: IMAGES.alleppeyAerial, place: "Alleppey", caption: "Timeless backwaters" },
  { img: IMAGES.athirappilly, place: "Athirappilly", caption: "Thundering waterfalls" },
  { img: IMAGES.fishingNets, place: "Kochi", caption: "Marine Drive sunsets" },
];

export const FEATURES = [
  { n: "01", title: "Curated Mumbai Departures", text: "Handpicked itineraries designed exclusively for travellers flying in from Mumbai — no guesswork, just seamless journeys." },
  { n: "02", title: "Comfortable Handpicked Hotels", text: "Every stay is inspected and chosen for comfort, cleanliness and location — from cosy hill resorts to luxury backwater houseboats." },
  { n: "03", title: "Trusted Private Drivers", text: "Courteous, background-verified drivers with clean private cabs so your family travels safely across Kerala." },
  { n: "04", title: "Personalised, Human Service", text: "A dedicated travel expert on WhatsApp before, during and after your trip — real people, not call centres." },
];

export const PROCESS = [
  { n: "01", title: "Share Your Dream", text: "Tell us your dates, travellers and what you'd love to see. Families, couples, groups — all welcome." },
  { n: "02", title: "Get a Free Custom Quote", text: "We craft a tailored itinerary with hotels, cabs and sightseeing, priced transparently." },
  { n: "03", title: "Confirm & Relax", text: "Approve the plan, pay securely, and we handle every booking down to airport pickup." },
  { n: "04", title: "Travel & Make Memories", text: "Arrive in Kerala to a warm welcome and 24x7 on-trip support until you're home." },
];

export const PACKAGES = [
  {
    slug: "3-days-kochi-munnar",
    title: "Kochi + Munnar Escape",
    duration: "3 Days / 2 Nights",
    price: "Starting from ₹XX,XXX",
    tagline: "A quick emerald getaway into the hills",
    image: IMAGES.munnarValley,
    highlights: ["Munnar tea gardens", "Mattupetty Dam", "Echo Point", "Fort Kochi walk"],
    itinerary: [
      { day: "Day 1", title: "Arrive Kochi → Munnar", text: "Airport pickup at Kochi, scenic drive to Munnar through spice plantations and waterfalls. Evening at leisure." },
      { day: "Day 2", title: "Munnar Sightseeing", text: "Tea Museum, Mattupetty Dam, Echo Point, Kundala Lake and rolling tea gardens." },
      { day: "Day 3", title: "Munnar → Kochi Departure", text: "Fort Kochi heritage walk, Chinese fishing nets, drop at Kochi airport." },
    ],
    included: ["2 nights hotel stay", "Daily breakfast", "Private AC cab", "Airport pickup & drop", "Toll, parking & driver charges"],
    excluded: ["Airfare Mumbai–Kochi", "Lunch & dinner", "Entry tickets & activities", "Personal expenses"],
  },
  {
    slug: "5-days-kochi-munnar-thekkady-alleppey",
    title: "Classic Kerala Discovery",
    duration: "5 Days / 4 Nights",
    price: "Starting from ₹XX,XXX",
    tagline: "Hills, wildlife and backwaters in one journey",
    image: IMAGES.alleppey2,
    highlights: ["Munnar tea hills", "Thekkady spice trails", "Periyar wildlife", "Alleppey houseboat"],
    itinerary: [
      { day: "Day 1", title: "Kochi → Munnar", text: "Pickup at Kochi, drive to Munnar, evening at leisure amid the hills." },
      { day: "Day 2", title: "Munnar Sightseeing", text: "Tea gardens, Eravikulam National Park, Mattupetty Dam and Echo Point." },
      { day: "Day 3", title: "Munnar → Thekkady", text: "Drive to Thekkady, spice plantation tour and optional Periyar boat safari." },
      { day: "Day 4", title: "Thekkady → Alleppey", text: "Board a private houseboat, cruise the backwaters with all meals on board." },
      { day: "Day 5", title: "Alleppey → Kochi Departure", text: "Check out, transfer to Kochi airport with fond memories." },
    ],
    included: ["4 nights stay incl. houseboat", "Daily breakfast + houseboat meals", "Private AC cab", "Airport pickup & drop", "All toll & driver charges"],
    excluded: ["Airfare Mumbai–Kochi", "Meals not mentioned", "Safari & entry tickets", "Personal expenses"],
    featured: true,
  },
  {
    slug: "7-days-complete-kerala",
    title: "Complete Kerala Grand Tour",
    duration: "7 Days / 6 Nights",
    price: "Starting from ₹XX,XXX",
    tagline: "The definitive God's Own Country experience",
    image: IMAGES.backwaterSunset,
    highlights: ["Munnar", "Thekkady", "Alleppey houseboat", "Kovalam beach", "Kochi heritage"],
    itinerary: [
      { day: "Day 1", title: "Arrive Kochi", text: "Airport pickup, Fort Kochi heritage walk and Chinese fishing nets." },
      { day: "Day 2", title: "Kochi → Munnar", text: "Scenic drive with waterfall stops, evening at leisure." },
      { day: "Day 3", title: "Munnar Sightseeing", text: "Tea gardens, national park and viewpoints." },
      { day: "Day 4", title: "Munnar → Thekkady", text: "Spice plantations and Periyar wildlife sanctuary." },
      { day: "Day 5", title: "Thekkady → Alleppey", text: "Overnight private houseboat on the backwaters." },
      { day: "Day 6", title: "Alleppey → Kovalam", text: "Drive south to the golden sands of Kovalam beach." },
      { day: "Day 7", title: "Kovalam → Departure", text: "Leisure morning, transfer to Trivandrum/Kochi airport." },
    ],
    included: ["6 nights premium stays", "Daily breakfast + houseboat meals", "Private AC cab throughout", "All airport transfers", "Toll, parking & driver charges"],
    excluded: ["Airfare", "Meals not mentioned", "Entry & activity tickets", "Personal expenses"],
  },
];

export const DESTINATIONS = [
  { name: "Munnar", tag: "Tea Country", img: IMAGES.munnarHero, text: "Endless rolling tea gardens wrapped in cool mountain mist." },
  { name: "Alleppey", tag: "Backwaters", img: IMAGES.alleppeyAerial, text: "Glide through palm-lined canals aboard a private houseboat." },
  { name: "Thekkady", tag: "Wildlife", img: IMAGES.munnarValley, text: "Spice trails and Periyar's elephants, tigers and birdlife." },
  { name: "Athirappilly", tag: "Waterfalls", img: IMAGES.athirappillyAerial, text: "Kerala's own Niagara thundering through emerald forest." },
  { name: "Kochi", tag: "Heritage", img: IMAGES.fishingNets, text: "Colonial lanes, Chinese fishing nets and Marine Drive sunsets." },
  { name: "Kovalam", tag: "Beaches", img: IMAGES.backwaterSunset, text: "Crescent beaches, lighthouses and gentle Arabian Sea breeze." },
];

export const TESTIMONIALS = [
  { name: "Priya & Rohan Mehta", from: "Mumbai", type: "Honeymoon", rating: 5, text: "Our honeymoon houseboat in Alleppey was straight out of a dream. Every detail from the Mumbai airport to the candlelit dinner was perfectly arranged." },
  { name: "The Iyer Family", from: "Andheri, Mumbai", type: "Family Tour", rating: 5, text: "Travelling with kids and my parents felt effortless. Clean cabs, patient driver and hotels that were exactly as promised. Highly recommended." },
  { name: "Suresh Nair", from: "NRI, Dubai", type: "Group Tour", rating: 5, text: "Booked a 7-day tour for 12 family members. Flawless coordination and genuinely warm service. Kerala Holidays Connect earned our trust." },
  { name: "Anjali Deshmukh", from: "Powai, Mumbai", type: "Family Tour", rating: 5, text: "Transparent pricing, no hidden costs and a real human on WhatsApp whenever we needed. The Munnar tea gardens were unforgettable." },
  { name: "Corporate Offsite — Fintech Co.", from: "Bandra, Mumbai", type: "Corporate", rating: 5, text: "45 employees, zero chaos. The team handled logistics beautifully and everyone came back raving about Thekkady." },
  { name: "Mr. & Mrs. Kulkarni", from: "Senior Travellers", type: "Family", rating: 5, text: "As senior citizens we worried about comfort. They chose gentle itineraries, ground-floor rooms and a caring driver. Bliss." },
];

export const FAQS = [
  { q: "Do you arrange flights from Mumbai to Kerala?", a: "We specialise in on-ground Kerala experiences — hotels, cabs and sightseeing. We're happy to advise on the best flights, but airfare is booked separately so you get the best available fares." },
  { q: "Are the tour packages customisable?", a: "Absolutely. Every itinerary is a starting point. Tell us your dates, budget and interests and we'll tailor a package just for you — honeymoon, family, group or corporate." },
  { q: "What is included in the package price?", a: "Typically accommodation, daily breakfast, a private AC cab with driver, airport pickup & drop, tolls and parking. Exact inclusions are listed on each package." },
  { q: "Is it safe for senior citizens and families?", a: "Yes. We choose comfortable hotels, gentle itineraries and verified, courteous drivers. Our team is reachable 24x7 on WhatsApp throughout your trip." },
  { q: "How do I book and pay?", a: "Share an enquiry, receive a free custom quote, and once you approve we confirm bookings with a secure advance payment. The balance is paid as per the agreed schedule." },
  { q: "Do you handle honeymoon and group tours?", a: "Yes — romantic houseboat honeymoons, large family groups, corporate offsites and NRI reunions are all part of what we do best." },
];

export const GALLERY = [
  IMAGES.munnarHero, IMAGES.alleppeyAerial, IMAGES.athirappilly, IMAGES.fishingNets,
  IMAGES.munnarValley, IMAGES.backwaterBoat, IMAGES.kathakali, IMAGES.alleppey2,
  IMAGES.athirappillyAerial, IMAGES.backwaterSunset, IMAGES.houseboatClose, IMAGES.hotel,
];

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "About Us", to: "/about" },
  { label: "Tour Packages", to: "/packages" },
  { label: "Honeymoon", to: "/honeymoon" },
  { label: "Family Tours", to: "/family-tours" },
  { label: "Group Tours", to: "/group-tours" },
  { label: "Custom Package", to: "/custom-package" },
  { label: "Gallery", to: "/gallery" },
  { label: "Reviews", to: "/reviews" },
  { label: "Blog", to: "/blog" },
  { label: "Contact", to: "/contact" },
];
